import { waitAuth } from "~/utils/middleware";

import { log } from "~/composables/log";
import { waitForPB } from "~/composables/pb";

/**
 * Middleware pour valider que la création d'une team sans customer
 * n'est autorisée que si l'utilisateur est un reseller avec l'abonnement reseller-object-storage
 */
export default defineNuxtRouteMiddleware(async () => {
	await waitAuth();
	await waitForPB();

	const pbUser = __pbUser();

	// Vérifier si l'utilisateur est un reseller
	if (!pbUser.isReseller) {
		log("❌ User is not a reseller - cannot create team without customer");
		throw createError({
			statusCode: 403,
			statusMessage: "Only resellers can create teams without customers"
		});
	}

	// Vérifier si le reseller a l'abonnement reseller-object-storage
	if (!pbUser.getTeam?.productTypes?.includes("reseller-object-storage")) {
		log("❌ Reseller does not have reseller-object-storage subscription");
		throw createError({
			statusCode: 403,
			statusMessage: "Reseller must have reseller-object-storage subscription to create teams without customers"
		});
	}

	// Vérifier si le reseller est activé
	if (pbUser.isDeactivated) {
		log("❌ Reseller is deactivated - cannot create team without customer");
		throw createError({
			statusCode: 403,
			statusMessage: "Reseller account is deactivated"
		});
	}

	log("✅ Reseller can create team without customer");
});
